import { MenuActionDefinition } from '../../components/common/DataTable/DataTable';
import { useUIEventTracker } from '../../hooks/useUIEventTracker';
import { Clearing } from '../../types/Clearing';
import {
  getClearingExcelUrl,
  getClearingPdfUrl,
} from '../../services/ClearingService';

export interface UseClearingActions {
  actions: MenuActionDefinition[];
}

export type ClearingAction = 'download_excel' | 'download_pdf';

export function useClearingActions(
  context: string,
  omit?: ClearingAction[]
): UseClearingActions {
  const trackEvent = useUIEventTracker(context);

  const availableActions = [
    {
      name: 'download_excel',
      label: 'Descargar Excel detalle',
      cb: (clearing: Clearing) => {
        trackEvent('download_clearing_excel');
        window.open(getClearingExcelUrl(clearing.id), '_blank');
      },
      disabled: (clearing: Clearing) => clearing.status !== 'cash_out_ok',
    },
    {
      name: 'download_pdf',
      label: 'Comprobante PDF',
      cb: (clearing: Clearing) => {
        trackEvent('download_clearing_pdf');
        window.open(getClearingPdfUrl(clearing.id), '_blank');
      },
      disabled: (clearing: Clearing) => clearing.status !== 'cash_out_ok',
    },
  ];

  const actions = omit
    ? availableActions.filter((action) => {
        return !omit.includes(action.name as ClearingAction);
      })
    : availableActions;

  return { actions };
}
